import { createAsync, query, useParams } from "@solidjs/router";
import { For } from "solid-js";
import { RIASRecordType } from "~/lib";

import { getByUser } from "~/_server/dynamoDB";
import { Subscription } from '~/components';

export const subscriptionsQuery = query( async ( userId: number ) => {
	"use server";

	return await getByUser( RIASRecordType.SUBSCRIPTION, userId, -1 );
}, "getCertifierSubscriptions" );

export const CertifierSubscriptions = () => {
	const { id } = useParams();

	const subscriptions = createAsync( () => subscriptionsQuery( parseInt( id ?? "0" ) ).then( r => r?.items ?? [] ) );

	return (
		<For each={subscriptions()} fallback={<p class="p-6 text-center text-sm text-zinc-500">No active memberships.</p>}>
			{s =>
				<div class="w-full my-4 overflow-hidden rounded-3xl border border-zinc-200 bg-gray-50 shadow-sm flex flex-nowrap gap-4">
					<Subscription subscription={s} longForm={true} />
				</div>
			}
		</For>
	)
}